<template>
  <span>
    <span class="description">
      <span v-if="secFlag===0">距活动开始：</span>
      <span v-else-if="secFlag===1 && timeNotLimited" style="color: #ff0000">正在抢购中</span>
      <span v-else>距活动结束：</span>
    </span>
    <span class="countdown">
      <span class="clock" v-if="secFlag === 0 && daysOnly">
        <s class="hand hand-h">
          <s class="digital">{{day[0]}}</s>
          <s class="digital">{{day[1]}}</s>
        </s>天
      </span>
      <span class="clock" v-else-if="secFlag===1 && timeNotLimited"></span>
      <span class="clock" v-else>
        <s class="hand hand-h">
          <s class="digital">{{hr[0]}}</s>
          <s class="digital">{{hr[1]}}</s>
        </s>:
        <s class="hand hand-m">
          <s class="digital">{{min[0]}}</s>
          <s class="digital">{{min[1]}}</s>
        </s>:
        <s class="hand hand-s">
          <s class="digital">{{sec[0]}}</s>
          <s class="digital">{{sec[1]}}</s>
        </s>
      </span>
    </span>

  </span>

</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  export default {
    props: ['startDT', 'endDT'],
    data () {
      return {
        day: '00',
        hr: '00',
        min: '00',
        sec: '00',
        daysOnly: false
      }
    },
    computed: {
      ...mapGetters(['secFlag']),
      // 无时间限制, 假定一周
      timeNotLimited () {
        const self = this
        if (self.startDT) {
          const start = Date.parse(new Date(self.startDT.year, self.startDT.month, self.startDT.dayOfMonth, self.startDT.hourOfDay, self.startDT.minute, self.startDT.second))
          const end = Date.parse(new Date(self.endDT.year, self.endDT.month, self.endDT.dayOfMonth, self.endDT.hourOfDay, self.endDT.minute, self.endDT.second))
          return end - start > 7 * 24 * 60 * 60 * 1000
        }
      }
    },
    watch: {
      'startDT': {
        handler: 'countdown',
        immediate: true
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_SECPROMOTION_INFO'
      ]),
      countdown: function () {
        const self = this
        this.timeInterval = setInterval(function () {
          const start = Date.parse(new Date(self.startDT.year, self.startDT.month, self.startDT.dayOfMonth, self.startDT.hourOfDay, self.startDT.minute, self.startDT.second))
          const end = Date.parse(new Date(self.endDT.year, self.endDT.month, self.endDT.dayOfMonth, self.endDT.hourOfDay, self.endDT.minute, self.endDT.second))
          const now = Date.parse(new Date())
          self.UPDATE_SECPROMOTION_INFO({now: now})
          let diff
          if (self.secFlag === 0) {
            diff = start - now
            self.daysOnly = (diff > 24 * 60 * 60 * 1000)
          } else if (self.secFlag === 1) {
            diff = end - now
          } else {
            clearInterval(self.timeInterval)
            self.day = '00'
            self.hr = '00'
            self.min = '00'
            self.sec = '00'
            console.log('end secflag', self.secFlag)
            return
          }
          let day = parseInt(diff / 1000 / 60 / 60 / 24)
          let hr = parseInt(diff / 1000 / 60 / 60 % 24)
          let min = parseInt(diff / 1000 / 60 % 60)
          let sec = parseInt(diff / 1000 % 60)
          self.day = day > 9 ? day.toString() : '0' + day
          self.hr = hr > 9 ? hr.toString() : '0' + hr
          self.min = min > 9 ? min.toString() : '0' + min
          self.sec = sec > 9 ? sec.toString() : '0' + sec
        }, 1000)
      }
    }
  }
</script>

<style scoped>
  .clock {
    display: inline-block;
    height: 1.5rem;
    vertical-align: top;
    font-family: arial;
    font-size: 0.6rem;
    line-height: 1.5rem;
  }
  .hand {
    text-decoration: none;
  }
  .digital {
    box-sizing: border-box;
    text-decoration: none;
    padding: 2px 3px;
    margin: 0 1px;
    border-radius: 3px;
    color: #fff;
    background: #666;
  }

</style>



// WEBPACK FOOTER //
// Countdown.vue?e89ce0e0